import api from "../api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "@/api/statusHTTP";

export const buscarFornecedores = async () => {
  const url = 'drp-blacklist/fornecedores';
  const {data, status} = await api.get(url, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.fornecedores;
}

export const buscarSegmentos = async () => {
  const url = 'drp-blacklist/segmentos';
  const {data, status} = await api.get(url, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.segmentos;
}

export const salvarSilenciamentoProdutos = async (params) => {
  const url = 'drp/blacklist';
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data;
}

export const aplicarListaImportada = async (parametros) => {
  const url = 'drp/blacklist/import';

  const config = {
    headers: {
      ...iniciarRequisicao(),
      'Content-Type': 'multipart/form-data'
    }
  };

  const formData = new FormData();
  formData.append('arquivo_importacao', parametros);

  const { status, data } = await api.post(url, formData, config).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.message;
}

export const salvarSilenciamentoMultiplosProdutos = async (params) => {
  const url = 'drp/blacklist/silenciar-multiplos';
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return;
}

export const buscarProdutosSileciados = async (parametros) => {
  const url = 'drp/blacklist';
  const {data, status} = await api.get(url, { params: parametros, headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data;
}

export const excluirProdutosSileciados = async (params) => {
  const url = `drp/blacklist/delete/${params.id || 0}`;
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data;
}
